import React, { useState, useRef, useEffect, useContext } from "react";
import { ContextApi } from "../../../App";
import { v4 as uuidv4 } from "uuid";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

function ProfessionalExperience({
  onMoveUp,
  onMoveDown,
  onElementDelete,
  preset
}) {
  const [element, setElement] = useState({
    id: uuidv4(),
    type: "professionalexperience",
    properties: {
      required: true,
      count: 1,
      placeholder: "Enter here...",
      label : 'Professional Experince'
    },
    fillableByCandidate: true,
    fillableByHR: false,
    disableField: false
  });

  const [modal, setModal] = useState(false);
  const contextData = useContext(ContextApi);
  // Refs
  const elementCount = useRef();
  const fillableCandidateRef = useRef();
  const fillableHRRef = useRef();
  const elementRequiredRef = useRef();
  const toggle = () => setModal(!modal);


  useEffect(() => {
    if (preset !== null && preset && preset !== undefined) {
      setElement((previousState) => {
        return { ...previousState, ...preset };
      });
    }
  }, [preset]);

  function onEdit() {
    setElement((previousState) => {
      previousState.properties.count = elementCount.current.value;
      previousState.properties.required = elementRequiredRef.current.checked;
      previousState.fillableByCandidate = fillableCandidateRef.current.checked;
      previousState.fillableByHR = fillableHRRef.current.checked;
      //   previousState.disableField = disableFieldRef.current.checked;
      return previousState;
    });
    toggle();
    contextData.setContextData({
      ...contextData.contextData,
      isEdit: !contextData.contextData.isEdit
    });
  }
  return (
    <div
      className="form-group form-builder-element mb-3"
      data={JSON.stringify(element)}>
      <button
        className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right"
        onClick={(e) => onElementDelete(e, element)}>
        <i className="fa fa-trash"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={toggle}>
        <i className="fa fa-asterisk"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveUp}>
        <i className="fa fa-chevron-up"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveDown}>
        <i className="fa fa-chevron-down"></i>
      </button>
      <div className="form-group">
        <div>
          <div>
            <h5>Employment Tenure</h5>
          </div>
          <div className="mb-2">
            <label htmlFor="">From Date (dd/mm/yy)</label>
            <input
              {...{
                className: "form-control",
                type: "date"
              }}
            />
          </div>
          <div className="mb-2">
            <label htmlFor="">To Date (dd/mm/yy)</label>
            <input
              {...{
                className: "form-control",
                type: "date"
              }}
            />
          </div>
          <div className="mb-2">
            <label htmlFor="">Total years of experience</label>
            <input
              className="form-control"
              type="text"
              placeholder={element.properties.placeholder}
            />
          </div>
          <div className="mb-2">
            <label htmlFor="">Reason for Leaving</label>
            <input
              className="form-control"
              type="text"
              placeholder={element.properties.placeholder}
            />
          </div>
          <div className="mb-2">
            <label htmlFor="">Salary (per annum)</label>
            <input
              className="form-control"
              type="text"
              placeholder={element.properties.placeholder}
            />
          </div>
          <div className="mt-2" style={{ position: "relative" }}>
            <h5>Supervisor/ HR Manager Details</h5>
          </div>
          <div className="mb-2">
            <label htmlFor="">Name</label>
            <input
              className="form-control"
              type="text"
              placeholder={element.properties.placeholder}
            />
          </div>
          <div className="mb-2">
            <label htmlFor="">Designation</label>
            <input
               className="form-control"
               type="text"
               placeholder={element.properties.placeholder}
            />
          </div>
          <div className="mb-2">
            <label htmlFor="">Mobile No.</label>
            <input
                className="form-control"
                type="text"
                placeholder={element.properties.placeholder}
            />
          </div>
        </div>
        <label
          style={{
            textAlign: "right",
            display: "inline-block",
            width: "100%",
            cursor: "pointer"
          }}>
          + Add more
        </label>
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit Professional Experience Properties</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Count of Employment Tenure</label>
            <input
              ref={elementCount}
              defaultValue={element.properties.count}
              type="number"
              className="form-control"
            />
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={elementRequiredRef}
              className="custom-control-input"
              id="requiredCheck"
              defaultChecked={element.properties.required}
            />
            <label className="custom-control-label" htmlFor="requiredCheck">
              Mandatory?
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableCandidateRef}
              className="custom-control-input"
              id="fillableCandidate"
              defaultChecked={element.fillableByCandidate}
            />
            <label className="custom-control-label" htmlFor="fillableCandidate">
              Can candidates edit this field?
            </label>
          </div>

          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableHRRef}
              className="custom-control-input"
              id="fillableHR"
              defaultChecked={element.fillableByHR}
            />
            <label className="custom-control-label" htmlFor="fillableHR">
              Can HRs edit this field?
            </label>
          </div>
          {/* <div className="custom-control custom-checkbox">
          <input
            ref={disableFieldRef}
            type="checkbox"
            className="custom-control-input"
            id="disableField"
            defaultChecked={element.disableField}
          />
          <label className="custom-control-label" htmlFor="disableField">
            Disable preFilled Field(only admin can edit)
          </label>
        </div> */}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onEdit}>
            Update
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ProfessionalExperience;
